<template>
    <tz-alert
        class="align-center text-center ma-0 px-6 py-4 text-md-h6 text-body-1 text-sm-body-1 info-banner"
        color="#FEFEC7"
        :value="show"
        :dismissible="dismissible"
        override-alert-role
        tabindex="0"
        :aria-label="bannerAriaLabel"
    >
        <span v-if="getLoading">
            <v-progress-circular
                indeterminate
                :size="50"
                color="primary"
                :width="7"
                :aria-label="$t('accessibility.loadingGeneric')"
                class="screen-center main-loading"
            />
        </span>
        <span v-else>
            <span v-if="shouldShowProfileCompletionCta">
                {{ $t('banner.promptCompleteRegistration.ctaMessage1') }}
                <a
                    class="banner-link"
                    data-testid="login-link"
                    @click="goToProfile"
                >
                    {{ $t('banner.promptCompleteRegistration.login') }}
                </a>
                <span v-html="$t('banner.promptCompleteRegistration.ctaMessage2')" />
                <a
                    class="banner-link"
                    @click="getUpdatedPatients"
                >
                    {{ $t('banner.promptCompleteRegistration.getUpdatedPatients') }}
                </a>
            </span>
            <span v-else>
                <a
                    class="banner-link"
                    data-testid="login-link"
                    @click="handleSignInClick(false)"
                >
                    {{ $t('banner.promptLogin.login') }}
                </a>
                {{ $t('banner.promptLogin.or') }}
                <a
                    class="banner-link"
                    data-testid="register-link"
                    @click="handleSignInClick(true)"
                >
                    {{ $t('banner.promptLogin.subscribe') }}
                </a>
                {{ $t('banner.promptLogin.ctaMessage') }}
            </span>
        </span>
    </tz-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import { authModule, isUsingKc } from '@/utils';
import TzAlert from '@/components/tzAlert/TzAlert';

export default {
    name: 'banner',
    components: {
        TzAlert,
    },
    props: {
        show: { type: Boolean, required: true },
        dismissible: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            getLocale: 'locale',
            getLoggedUser: `${authModule}/getLoggedUser`,
            getProfileUrl: `${authModule}/getProfileUrl`,
            getIsOwnerRegisterComplete: `${authModule}/getIsOwnerRegisterComplete`,
            getLoading: `${authModule}/getLoading`,
        }),
        shouldShowProfileCompletionCta() {
            if (!isUsingKc) {
                return false;
            }
            return !!(this.getLoggedUser && !this.getIsOwnerRegisterComplete);
        },
        bannerAriaLabel() {
            return this.shouldShowProfileCompletionCta ? this.$t('appt.accessibility.profileCompletionOption') : this.$t('appt.accessibility.registrationOption');
        },
    },
    methods: {
        handleSignInClick(isRegister) {
            this.$emit('handleSignInClick', isRegister);
        },
        goToProfile() {
            window.open(`${this.getProfileUrl}/dashboard?locale=${this.getLocale}`, '_blank');
        },
        async getUpdatedPatients() {
            await this.$store.dispatch('kcAuth/onLoginSuccess');
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

.info-banner {
    color: $text-dark-primary !important;
    z-index: 1;
    box-shadow: 0 1px 6px #00000029 !important;

    div.v-alert__content {
        line-height: 25px;
    }

    i.theme--light.v-icon {
        color: $text-dark-primary !important;
    }
}

.banner-link {
    color: #0071B9 !important;
    justify-content: center;
    display: inline-block;
}

a {
    text-decoration: underline;
}
</style>
